import { LocationMatchesState, LocationMatchesActionTypes, LOCATION_MATCHES_REQUEST, LOCATION_MATCHES_SUCCESS, LOCATION_MATCHES_FAILURE } from "store/reducers/lodgingOption/locationMatches/types";

const defaultState: LocationMatchesState = {
  isLoading: false,
  errorMessage: ""
};

export default function locationMatches(state = defaultState, action: LocationMatchesActionTypes): LocationMatchesState {
  switch (action.type) {
    case LOCATION_MATCHES_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LOCATION_MATCHES_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LOCATION_MATCHES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};